import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,[(_vm.diagnosticStats.tsa)?_c(VCol,{attrs:{"cols":"3"}},[_c('tsa-chart',{attrs:{"stats":_vm.diagnosticStats}})],1):_vm._e(),_c(VCol,{attrs:{"cols":_vm.diagnosticStats.tsa ? 9 : 12}},[_c('composite-diag-chart',{attrs:{"stats":_vm.diagnosticStats}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }